import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
    Checkbox, Form, Icon, Input, Select, Tag, Card, Layout, Col, Row, Breadcrumb,
} from 'antd';
import { Link } from 'react-router-dom';
import { SFButton } from '../../../../components/SF-UI';
import { bike_types, formItemLayout, checkboxItemLayout } from './statics';
import { statics } from '../../BikeManagement/components/statics';
import { searchByBrandRequest } from '../../BikeManagement/redux/actions/search_by_brand.actions';
import { createBikeModelRequest } from '../redux/actions/create_bike_model.actions';

const mapStateToProps = (state) => {
    const { filteredBrands } = state.PlatformManagement.Bike_management;
    return { filteredBrands };
}; const FormItem = Form.Item; const { Option } = Select; const BreadcrumbItem = Breadcrumb.Item;
const layout_position = { padding: '0 4%' }; const
    breadcrumb_position = { margin: '0 0 1% 0' };

export default connect(mapStateToProps, null)(class BikeAddModel extends Component {
    state = {
        ref_bike_brand: '',
        weight: '',
        name: '',
        cc: '',
        mileage_limit: '',
        bike_type: '',
        min_age: '',
        wwym_priority: '',
        leadomatic_priority: '',
        alternative_names: [],
        model_variation: '',
        check_luggage: false,
        always_manual_price: false,
        check_race_replica: false,
        we_dont_want: false,
        inputVisible: false,
        inputValue: '',
        average_profit: 0,
    };

    searchByBrand = value => this.props.dispatch(searchByBrandRequest(value));

    handleChange(name, value) {
        if (name === 'ref_bike_brand') {
            this.setState({ ref_bike_brand: this.props.filteredBrands[0]._id });
        } else {
            this.setState({ [name]: value });
        }
    }

    showInput = () => this.setState({ inputVisible: true }, () => this.input.focus());

    handleClose = (removedTag) => {
        const alternative_names = this.state.alternative_names.filter(tag => tag !== removedTag);
        this.setState({ alternative_names });
    };

    handleInputConfirm = () => {
        let { inputValue, alternative_names } = this.state;
        if (inputValue && alternative_names.indexOf(inputValue) === -1) alternative_names = [...alternative_names, inputValue];
        this.setState({ alternative_names, inputVisible: false, inputValue: '' });
    };

    handleSubmit = (event) => {
        event.preventDefault();
        const {
            cc, alternative_names, wwym_priority, we_dont_want, min_age, mileage_limit, leadomatic_priority, model_variation,
            check_race_replica, check_luggage, bike_type, always_manual_price, ref_bike_brand, name, weight, average_profit,
        } = this.state; const
            { dispatch } = this.props;
        dispatch(createBikeModelRequest({
            cc,
            alternative_names,
            wwym_priority,
            we_dont_want,
            min_age,
            mileage_limit,
            leadomatic_priority,
            model_variation,
            check_race_replica,
            check_luggage,
            bike_type,
            always_manual_price,
            ref_bike_brand,
            name,
            weight,
            average_profit,
        }));
    };

    render() {
        const {
            inputValue, inputVisible, alternative_names, name, bike_type,
            ref_bike_brand, wwym_priority, cc, leadomatic_priority, mileage_limit,
            min_age, weight,
        } = this.state; const
            { filteredBrands } = this.props;
        return (
            <Layout style={layout_position}>
                <Col span={24}>
                    <Breadcrumb style={breadcrumb_position}>
                        <BreadcrumbItem><Link to="/PlatformManagement/BikeManagement">Bike Management</Link></BreadcrumbItem>
                        <BreadcrumbItem>Add New Model</BreadcrumbItem>
                    </Breadcrumb>
                </Col>
                <Col span={12}>
                    <h3 className="page-title">Add New Model</h3>
                </Col>
                <Card className="border-shadows">
                    <Form style={{ paddingTop: '10px' }}>
                        <Row>
                            <Col span={12}>
                                <FormItem label="Brand" {...formItemLayout}>
                                    <Select
                                        mode="tags"
                                        notFoundContent="No Makes Found"
                                        filterOption={false}
                                        onSearch={this.searchByBrand}
                                        onMouseEnter={false}
                                        onChange={value => this.handleChange('ref_bike_brand', value)}
                                        placeholder="Select Make"
                                    >
                                        {filteredBrands && filteredBrands.map(brand => <Option key={brand._id} value={brand._id}>{brand.name}</Option>)}
                                    </Select>
                                </FormItem>
                            </Col>
                            <Col span={12}>
                                <FormItem className="create_model_label" label="We Want Priority" {...formItemLayout}>
                                    <Select
                                        onChange={value => this.handleChange('wwym_priority', value)}
                                        placeholder="Select We Want Priority"
                                    >
                                        {statics.bike_priorities.map(pr => <Option key={pr.value}>{pr.label}</Option>)}
                                    </Select>
                                </FormItem>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={12}>
                                <FormItem className="create_model_label" label="Model Name" {...formItemLayout}>
                                    <Input
                                        onChange={event => this.handleChange('name', event.target.value)}
                                        placeholder="Model Name"
                                    />
                                </FormItem>
                            </Col>
                            <Col span={12}>
                                <FormItem className="create_model_label" label="Bike Type" {...formItemLayout}>
                                    <Select
                                        onChange={value => this.handleChange('bike_type', value)}
                                        placeholder="Select Bike Type"
                                    >
                                        {bike_types && bike_types.map((type, index) => <Option key={index} value={type.label}>{type.label}</Option>)}
                                    </Select>
                                </FormItem>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={12}>
                                <FormItem className="create_model_label" label="Bike CC" {...formItemLayout}>
                                    <Input
                                        onChange={event => this.handleChange('cc', event.target.value)}
                                        placeholder="Bike CC"
                                    />
                                </FormItem>
                            </Col>
                            <Col span={12}>
                                <FormItem className="create_model_label" label="Mileage Limit" {...formItemLayout}>
                                    <Select
                                        onChange={value => this.handleChange('mileage_limit', value.toString())}
                                        placeholder="Select Mileage Limit"
                                    >
                                        {statics.bike_mileage_limit.map((limit, index) => <Option key={index} value={limit.value}>{limit.label}</Option>)}
                                    </Select>
                                </FormItem>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={12}>
                                <FormItem className="create_model_label" label="Weight(kg)" {...formItemLayout}>
                                    <Input
                                        onChange={event => this.handleChange('weight', event.target.value)}
                                        placeholder="Bike Weight"
                                    />
                                </FormItem>
                            </Col>
                            <Col span={12}>
                                <FormItem className="create_model_label" label="Minimum Age" {...formItemLayout}>
                                    <Select
                                        onChange={value => this.handleChange('min_age', value)}
                                        placeholder="Select Minimum Age"
                                    >
                                        {statics.bike_min_age.map(age => <Option key={age.value}>{age.label}</Option>)}
                                    </Select>
                                </FormItem>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={12}>
                                <FormItem className="create_model_label" label="Alternative Names" {...formItemLayout}>
                                    {alternative_names.map(tag => <Tag key={tag} closable afterClose={() => this.handleClose(tag)}>{tag}</Tag>)}
                                    {inputVisible && (
                                        <Input
                                            ref={input => this.input = input}
                                            type="text"
                                            size="small"
                                            style={{ width: 78 }}
                                            defaultValue={inputValue}
                                            onChange={event => this.handleChange('inputValue', event.target.value)}
                                            onPressEnter={this.handleInputConfirm}
                                        />
                                    )}
                                    {!inputVisible && (
                                        <Tag onClick={this.showInput} style={{ background: '#fff', borderStyle: 'dashed' }}>
                                            <Icon type="plus" />
                                            {' '}
                                            New Name
                                        </Tag>
                                    )}
                                </FormItem>
                            </Col>
                            <Col span={12}>
                                <FormItem className="create_model_label" label="Leadomatic Priority" {...formItemLayout}>
                                    <Select
                                        onChange={value => this.handleChange('leadomatic_priority', value)}
                                        placeholder="Select Lead-o-matic Priority"
                                    >
                                        {statics.bike_priorities.map(pr => <Option key={pr.value}>{pr.label}</Option>)}
                                    </Select>
                                </FormItem>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={12} />
                            <Col span={12}>
                                <FormItem className="create_model_label" label="Model Variation" {...formItemLayout}>
                                    <Input
                                        onChange={event => this.handleChange('model_variation', event.target.value)}
                                        placeholder="Model Variation"
                                    />
                                </FormItem>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={12}>
                                <Row>
                                    <Col span={12}>
                                        <FormItem className="create_model_label" label="Check Luggage" {...checkboxItemLayout}>
                                            <Checkbox onChange={event => this.handleChange('check_luggage', event.target.checked)} />
                                        </FormItem>
                                    </Col>
                                    <Col offset={1} span={11}>
                                        <FormItem className="create_model_label" label="Price Manually" {...checkboxItemLayout}>
                                            <Checkbox onChange={event => this.handleChange('always_manual_price', event.target.checked)} />
                                        </FormItem>
                                    </Col>
                                </Row>
                            </Col>
                            <Col span={12}>
                                <Row>
                                    <Col span={12}>
                                        <FormItem className="create_model_label" label="Check Race Replica" {...checkboxItemLayout}>
                                            <Checkbox onChange={event => this.handleChange('check_race_replica', event.target.checked)} />
                                        </FormItem>
                                    </Col>
                                    <Col offset={1} span={11}>
                                        <FormItem className="create_model_label" label="We Don`t Want Bike" {...checkboxItemLayout}>
                                            <Checkbox onChange={event => this.handleChange('we_dont_want', event.target.checked)} />
                                        </FormItem>
                                    </Col>
                                </Row>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={12} />
                            <Col span={12}>
                                <SFButton
                                    type="primary"
                                    disabled={
                                        !cc.length || !alternative_names.length || !wwym_priority.length || !bike_type.length
                                        || !weight.length || !min_age.length || !mileage_limit.length || !leadomatic_priority.length
                                        || !ref_bike_brand.length || !name.length
                                    }
                                    style={{ float: 'right', marginLeft: 15 }}
                                    onClick={this.handleSubmit}
                                >
                                    Add
                                </SFButton>
                                <SFButton type="secondary" style={{ float: 'right' }}><Link to="/PlatformManagement/BikeManagement">Back</Link></SFButton>
                            </Col>
                        </Row>
                    </Form>
                </Card>
            </Layout>
        );
    }
});



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/Bike_model_create/components/BikeAddModel.js